import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAdminAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const { admin, login, error } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (admin) navigate("/admin/dashboard");
  }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/admin/dashboard");
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-5 bg-background text-foreground">
      <div className="lg:col-span-3 relative grid-bg overflow-hidden hidden lg:flex items-end p-12">
        <div className="relative z-10 max-w-lg">
          <div className="w-12 h-12 bg-foreground text-background flex items-center justify-center font-heading font-black text-lg mb-8">
            VM
          </div>
          <h1 className="font-heading font-black tracking-tighter text-5xl leading-[0.95]">
            Painel<br />administrativo<br /><span className="text-muted-foreground">VM Shopping</span>
          </h1>
          <p className="mt-6 text-muted-foreground max-w-md leading-relaxed">
            Controle financeiro, ocupação, documentos legais e cobrança automatizada
            de todas as 65 unidades do complexo.
          </p>
        </div>
      </div>

      <div className="lg:col-span-2 flex flex-col justify-center px-6 sm:px-10 lg:px-16 py-12 border-l border-border">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-10" data-testid="admin-back-home">
          <ArrowLeft size={14} /> Voltar
        </Link>

        <div className="label-tag mb-3">Acesso restrito</div>
        <h2 className="font-heading font-black tracking-tighter text-3xl mb-2">Entrar como Admin</h2>
        <p className="text-sm text-muted-foreground mb-10">Use suas credenciais corporativas.</p>

        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-2">
            <Label className="label-tag">E-mail</Label>
            <Input
              data-testid="admin-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="h-12 rounded-sm bg-background border-border font-mono text-sm"
            />
          </div>
          <div className="space-y-2">
            <Label className="label-tag">Senha</Label>
            <Input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="h-12 rounded-sm bg-background border-border font-mono text-sm"
            />
          </div>

          {error && (
            <div data-testid="admin-login-error" className="text-sm border border-destructive/40 bg-destructive/5 text-destructive px-4 py-3 rounded-sm">
              {error}
            </div>
          )}

          <Button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-sm bg-foreground text-background hover:bg-foreground/90"
          >
            <ShieldCheck size={16} className="mr-2" />
            {loading ? "Entrando..." : "Entrar no painel"}
          </Button>
        </form>
      </div>
    </div>
  );
}
